<div
  class="mx-auto mt-10 flex w-full max-w-[856px] flex-col items-center rounded-md border border-border-3 bg-white px-24 py-14"
>
  <p class="my-4 self-start text-left text-xl leading-none">
    {{ 'onboarding.add-the-size-guide-button-to-your-storefront' | translate }}
  </p>
  <p class="max-w-[548px] self-start text-left text-[15px] leading-[24px] text-text-2">
    {{ 'onboarding.choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages' | translate }}
  </p>

  <div class="mt-10 flex w-full flex-col gap-6">
    <button
      data-cy="method-embed"
      class="group flex items-center gap-5 rounded-lg border border-border-3 px-5 py-5 text-left transition-all hover:border-primary disabled:cursor-default disabled:opacity-60 disabled:hover:border-border-3"
      [disabled]="embedLoading()"
      (click)="onSelectMethod('embed')"
    >
      <div class="flex grow flex-col gap-2">
        <p class="text-lg leading-none">
          {{ 'onboarding.enable-app-embed' | translate }}
        </p>
        <p class="text-[15px] leading-[24px] text-text-2">
          {{ 'onboarding.automatically-display-the-size-guide-button-on-all-product-pages' | translate }}
        </p>
      </div>

      @if (embedInstalled()) {
        <span
          data-cy="embed-installed"
          class="flex shrink-0 items-center gap-2 self-start rounded-[4px] bg-green-50 px-4 py-2 text-sm font-medium text-green-700"
        >
          <mat-icon class="material-icons-outlined !size-[18px] !text-[18px] !leading-none">check_circle</mat-icon>
          {{ 'onboarding.installed' | translate }}
        </span>
      } @else if (embedLoading() || checking()) {
        <span class="flex shrink-0 items-center gap-2 self-start rounded-full bg-border-1 px-4 py-2 text-text-1">
          <mat-spinner [diameter]="18" />
        </span>
      } @else {
        <span
          class="flex shrink-0 items-center gap-2 self-start rounded-[4px] bg-border-1 px-4 py-2 text-sm font-medium text-text-1 transition-colors group-hover:bg-primary group-hover:text-white"
        >
          {{ 'onboarding.open' | translate }}
          <mat-icon class="material-icons-outlined !size-[18px] !text-[18px] !leading-none">open_in_new</mat-icon>
        </span>
      }
    </button>

    <div class="flex items-center justify-start gap-2 text-[15px] leading-[24px] text-text-2">
      @if (blockInstalled()) {
        <span data-cy="block-installed" class="inline-flex items-center gap-1 font-medium text-green-700">
          <mat-icon class="material-icons-outlined !size-[16px] !text-[16px] !leading-none">check_circle</mat-icon>
          {{ 'onboarding.app-block-installed-on-your-product-page' | translate }}
        </span>
      } @else {
        <button
          data-cy="method-block"
          class="inline-flex items-center gap-1 font-medium text-primary underline-offset-2 hover:underline disabled:cursor-default disabled:opacity-60 disabled:hover:no-underline"
          [disabled]="blockLoading()"
          (click)="onSelectMethod('block')"
        >
          @if (blockLoading()) {
            <mat-spinner [diameter]="16" />
          }
          {{ 'onboarding.prefer-to-place-the-button-in-a-specific-spot-on-your-product-page' | translate }}
        </button>
      }
    </div>
  </div>

  <div class="mt-10 flex w-full items-center gap-6">
    <button mat-button (click)="onBack()">
      {{ 'common.back' | translate }}
    </button>

    @if (embedInstalled() || blockInstalled()) {
      <button mat-flat-button data-cy="continue" (click)="onContinue()">
        {{ 'common.continue' | translate }}
      </button>
    } @else {
      <button mat-stroked-button data-cy="skip" (click)="skip.emit()">
        {{ 'onboarding.skip-for-now' | translate }}
      </button>
    }
  </div>
</div>
